import { IUser } from "@vmosolutions/oc-interfaces";

export type AcknowledgementRole = "own" | "dispatcher" | "crew";

export type AcknowledgedUser = { user?: IUser | string };
type MessageLike = {
  user?: IUser | string;
  fromCrew?: boolean;
  acknowledgedBy?: AcknowledgedUser[];
};

export interface IAcknowledgementState {
  /** Who sent the message, relative to the current user. */
  role: AcknowledgementRole;
  isOwnMessage: boolean;
  isFromCrew: boolean;
  /** At least one acknowledgement exists. */
  hasBeenAcknowledged: boolean;
  /** The current user is among the acknowledgers. */
  currentUserAcknowledged: boolean;
  /** Number of acknowledgements. */
  count: number;
}

const idOfUser = (user?: IUser | string): string | undefined => (typeof user === "string" ? user : user?._id);

/**
 * Derives an OpsLink message's acknowledgement role/state once, so the event
 * table and event display can drive their tooltips, labels, colours and icons
 * off a single source instead of re-deriving the same isOwnMessage / isFromCrew
 * / ack-state ternaries in each spot.
 */
export function getAcknowledgementState(message: MessageLike, currentUserId?: string): IAcknowledgementState {
  const acknowledgedBy = Array.isArray(message.acknowledgedBy) ? message.acknowledgedBy : [];
  const isFromCrew = message.fromCrew === true;
  const isOwnMessage = !!message.user && idOfUser(message.user) === currentUserId;
  const role: AcknowledgementRole = isOwnMessage ? "own" : isFromCrew ? "crew" : "dispatcher";
  const count = acknowledgedBy.length;

  return {
    role,
    isOwnMessage,
    isFromCrew,
    hasBeenAcknowledged: count > 0,
    currentUserAcknowledged: !!currentUserId && acknowledgedBy.some((acknowledgedUser) => idOfUser(acknowledgedUser.user) === currentUserId),
    count,
  };
}
